import AppTextField from "@/components/AppTextField";
import CopyButton from "@/components/CopyButton";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import { getTaskId, getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import { Box, Stack, InputAdornment } from "@mui/material";
import { QRCodeCanvas } from "qrcode.react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "@/pages/security/css/index.module.less";
import PasteButton from "@/components/PasteButton";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";

const GOOGLE_AUTH_ANDROID_LINK = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2';
const GOOGLE_AUTH_IOS_LINK = 'https://apps.apple.com/app/id388497605';

function SecurityGABind() {
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const [initData, setInitData] = useState();
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    _initData();
  }, []);

  const _initData = async () => {
    const res = await axiosInstance.post(API.GA_KEY);
    setInitData(res);
  }

  const handleNextStep = () => {
    setStep(2);
  };

  const _onDownloadGA = () => {
    // 根据ios/android跳转两个商店 google play download url.
    window.open(GOOGLE_AUTH_ANDROID_LINK, '_blank');
  }

  const handleSubmit = async () => {
    setLoading(true);
    try {
      await axiosInstance.post(API.GA_BIND, {
        taskId: getTaskId(),
        code: code,
      });
      // TODO: toast提示用户绑定成功
      enqueueSnackbar(t('successful'), { variant: 'success' })
      dispatch(getUserInfo());
      navigate(-1);
    } finally {
      setLoading(false);
    }
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('google_authenticator')}</div>
      </Box>
      {step === 1 && (
        <Box className={classes["download-install-wrap"]}>
          <div className={classes["ga-content-wrap"]}>
            <div>
              <p className="h6">{t('download_install')}</p>
              <p className="tiny">{t('download_install_prompt')}</p>
            </div>
            <Box onClick={_onDownloadGA} className='text-center'><img src="/images/account/google_store.svg" alt=""/></Box>
          </div>
        </Box>
      )}
      {step === 2 && initData && (<Box className={classes["backup-key-wrap"]}>
        <div className={classes["ga-content-wrap"]}>
          <div>
            <p className="h6">{t('backup_key')}</p>
            <p className="tiny">{t('save_backup_key')}</p>
          </div>
          <div className='text-center'>
            <QRCodeCanvas marginSize={2} value={initData.qrCode} size={120}/>
            
          </div>
          <Stack className={classes['qr-wrap']} direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
            <div className='text-primary text-break'>{initData.key}</div>
            <CopyButton value={initData.key} />
          </Stack>
        </div>
        {/* TODO: <PasteButton /> */}
        <AppTextField
          label={t('google_authenticator_code')}
          placeholder={t('code')}
          onChange={(e) => {
            const value = e.target.value.trim();
            if (/^\d{0,6}$/.test(value)) {
              setCode(value);
            }
          }}
          required
          value={code}
          fullWidth
          sx={{ mb: 4 }}
          clearable
          onClear={() => setCode('')}
          type="number"
          inputMode="numeric"
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <PasteButton onPaste={(text) => setCode(text)} />
              </InputAdornment>
            ),
          }}
        />
        {/*<AppLoadingButton*/}
        {/*  fullWidth*/}
        {/*  loading={loading}*/}
        {/*  variant="contained"*/}
        {/*  color="primary"*/}
        {/*  size="large"*/}
        {/*  type="submit"*/}
        {/*>*/}
        {/*  {t('confirm')}*/}
        {/*</AppLoadingButton>*/}
      </Box>)}
      <Box className={classes["fixed-button"]}>
        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          disabled={step == 2 && (!code || code.length < 6)}
          onClick={step === 1 ? handleNextStep : handleSubmit} // 根据步骤动态处理点击事件
        >
          {step === 1 ? t('next') : t('confirm')}
        </AppLoadingButton>
      </Box>
    </Box>
  </>);
}

export default SecurityGABind;
